module.exports = __webpack_public_path__ + "static/media/wrench.4261c838.svg";